import type { SerializedStyles, Theme } from "@emotion/react";
import { faFile } from "@fortawesome/pro-regular-svg-icons";

import { CircularIcon, type CircularIconAviarySize } from "@aviary/components/CircularIcon";

interface Props {
  /**
   * size of the CircularIcon
   */
  size?: CircularIconAviarySize;
  /**
   * custom css for the container of the icon
   */
  layoutStyles?:
    | SerializedStyles
    | (SerializedStyles | ((theme: Theme) => SerializedStyles))[]
    | ((theme: Theme) => SerializedStyles);
}

const AttachmentFileIcon = ({ size = "xsmall", layoutStyles }: Props) => {
  return (
    <div css={layoutStyles}>
      <CircularIcon icon={faFile} size={size} isColor="success" />
    </div>
  );
};

export { AttachmentFileIcon };
